/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ControlAccessRequestResponse
 */
export interface ControlAccessRequestResponse {
    /**
     * 
     * @type {string}
     * @memberof ControlAccessRequestResponse
     */
    request_id: string;
    /**
     * 
     * @type {string}
     * @memberof ControlAccessRequestResponse
     */
    requestor_email: string;
}

/**
 * Check if a given object implements the ControlAccessRequestResponse interface.
 */
export function instanceOfControlAccessRequestResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "request_id" in value;
    isInstance = isInstance && "requestor_email" in value;

    return isInstance;
}

export function ControlAccessRequestResponseFromJSON(json: any): ControlAccessRequestResponse {
    return ControlAccessRequestResponseFromJSONTyped(json, false);
}

export function ControlAccessRequestResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ControlAccessRequestResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'request_id': json['request_id'],
        'requestor_email': json['requestor_email'],
    };
}

export function ControlAccessRequestResponseToJSON(value?: ControlAccessRequestResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'request_id': value.request_id,
        'requestor_email': value.requestor_email,
    };
}

